import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const getEmployees = async () => axios.get(Routes.GET_EMPLOYEES);

export const useGetEmployees = () =>
  useQuery({
    queryKey: [Keys.EMPLOYEES],
    queryFn: getEmployees,
    cacheTime: Infinity,
  });
